import { Box, Flex, Thumbnail } from 'dash-ui';
import styled, { css } from 'styled-components';

export const GridBox = styled(Box)<{ propertiesLength: number }>`
  display: grid;
  grid-template-columns: repeat(
    ${({ propertiesLength }) => (propertiesLength === 1 ? 1 : 2)},
    1fr
  );
  gap: ${({ theme }) => theme.space * 2}px;

  .portfolio {
    overflow: hidden;
  }
  .item-1 {
    border-radius: ${({ propertiesLength }) =>
      propertiesLength === 1 ? '8px 8px 0 0' : '8px 0 0 0'};
    grid-row: ${({ propertiesLength }) => (propertiesLength > 2 ? '1 / 3' : 0)};
  }
  .item-2 {
    border-radius: 0 8px 0 0;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    gap: ${({ theme }) => theme.space * 1.5}px;
  }
`;

export const StyledImage = styled(Thumbnail)`
  border-radius: ${({ theme }) => theme.space * 2}px
    ${({ theme }) => theme.space * 2}px 0 0;
`;

export const portfolioLockMaskStyle = css`
  top: ${({ theme }) => theme.space * 2}px;
  width: calc(100% - ${({ theme }) => theme.space * 2 * 2}px);
  height: calc(100% - ${({ theme }) => theme.space * 2}px);
  border-radius: ${({ theme }) => theme.space * 2}px
    ${({ theme }) => theme.space * 2}px 0 0;
`;

export const VerifiedBadgeWrapper = styled(Flex)`
  position: absolute;
  top: ${({ theme }) => theme.space * 5}px;
  left: ${({ theme }) => theme.space * 5}px;
  z-index: 1;
`;
